import { BaseSearch } from '../BaseSearch';

export class BasicSearch extends BaseSearch<String> {
}
// Expose on legacy global namespace so plain-JS files (e.g. add_report_modal.js) can access app.model.search.BasicSearch
(window as any).app = (window as any).app || {};
(window as any).app.model = (window as any).app.model || {};
(window as any).app.model.search = (window as any).app.model.search || {};
(window as any).app.model.search.BasicSearch = BasicSearch;
